const _import = require('./_import_' + process.env.NODE_ENV);

export default [
  {
    path: '*',
    name: '404',
    component: _import('error/404')
  },
  {
    path: '/505',
    name: '505',
    component: _import('error/505')
  }
];



// WEBPACK FOOTER //
// ./src/router/error.router.js